export const PATHNAMES = {
  Support: 'https://support.brandlive.com', // external link
  WhatsNew: 'https://www.brandlive.com/whats-new',
  Admin: {
    Projects: '/admin/projects',
    Series: '/admin/series',
    People: {
      PeopleMain: '/admin/people',
      SelectedPasscodeList: '/admin/people/passcode-list/:uuid',
      PaidLists: '/admin/people/paid-lists',
      SelectedPaidList: '/admin/people/paid-list/:uuid',
    },
    Settings: {
      Settings: '/admin/settings',
      Admins: '/admin/settings/admins',
      Integrations: '/admin/settings/integrations',
      ApiKeys: '/admin/settings/api-keys',
    },
    AnalyticsLink: '/admin/analytics',
    Profile: '/admin/profile',
    Content: '/admin/content',
    ContentSubLevels: {
      Documents: {
        All: '/admin/content/documents/all',
        Pdf: '/admin/content/documents/pdf',
        Word: '/admin/content/documents/word',
        Excel: '/admin/content/documents/excel',
        Powerpoint: '/admin/content/documents/powerpoint',
        Misc: '/admin/content/documents/misc',
      },
      Images: '/admin/content/images',
      Videos: {
        Recorded: '/admin/content/videos/recorded',
        Uploaded: '/admin/content/videos/uploaded',
        Archive: '/admin/content/videos/archive',
      },
      Fonts: '/admin/content/fonts',
      Palettes: '/admin/content/palettes',
      Themes: '/admin/content/themes',
      Templates: '/admin/content/templates',
      Products: '/admin/content/products',
    },
  },
  Choose: '/choose',
  Edit: {
    Root: '/project/edit/:projectUuid/:language/*',
  },
};
